<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedValue !== null" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold Payment method
        .px-1.neutral400--text |
        .text-xs.primary--text.font-medium {{ displayValue }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold Payment method

    .white
      .font-semibold.text-sm.px-4.pt-4.pb-2 Filter by payment method
      div
        .d-flex.text-sm.py-2.px-4
          yz-checkbox(v-model="isPanel" @change="updateSelection('panel')")
          .ml-4 Panel
        v-divider.basic300
      .pb-2
        .d-flex.text-sm.py-2.px-4
          yz-checkbox(v-model="isSelfPay" @change="updateSelection('self-pay')")
          .ml-4 Self-pay

    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="isPanel || isSelfPay" @click="clear") Clear
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="!isPanel && !isSelfPay") Apply
</template>

<script>
export default {
  name: 'FilterPaymentMethodSimple',
  props: {
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    showMenu: false,
    isPanel: null,
    isSelfPay: null,
    selectedValue: null,
  }),
  computed: {
    displayValue() {
      if (this.selectedValue === 'panel') return 'Panel'
      if (this.selectedValue === 'self-pay') return 'Self-pay'
      return ''
    }
  },
  watch: {
    filter: {
      handler(val) {
        if (!val?.key) {
          this.clearData()
        }
      },
      deep: true
    }
  },
  methods: {
    updateSelection(value) {
      if (value === 'panel') {
        this.isPanel = true
        this.isSelfPay = false
      } else if (value === 'self-pay') {
        this.isSelfPay = true
        this.isPanel = false
      }
    },
    clearData() {
      this.isPanel = null
      this.isSelfPay = null
      this.selectedValue = null
    },
    clear() {
      this.clearData()
      this.$emit('update:filter', {})
    },
    apply() {
      this.showMenu = false
      if (this.isPanel) {
        this.selectedValue = 'panel'
        this.$emit('update:filter', { key: 'panel__isnull', value: false })
      } else if (this.isSelfPay) {
        this.selectedValue = 'self-pay'
        this.$emit('update:filter', { key: 'panel__isnull', value: true })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
</style>
